export default __webpack_public_path__ + "0043d7ce272911e678e707556fc1dc87.svg";